<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content artist-compare-page'>
        <div class='artist-compare-toolbar'>
          <el-form class='artist-compare-search-form' :model='searchCondition' inline size='mini'>
            <el-form-item label='红人Id(星象仪)'>
              <el-input v-model='searchCondition.artist_id' class='artist-compare-id-input'
                        placeholder='红人Id' clearable></el-input>
            </el-form-item>
            <el-form-item label='红人昵称(星象仪)'>
              <el-input v-model='searchCondition.nickname' class='artist-compare-name-input'
                        placeholder='红人昵称' clearable></el-input>
            </el-form-item>
            <el-form-item label='红人Id(星广汇)'>
              <el-input v-model='searchCondition.ad_artist_id' class='artist-compare-id-input'
                        placeholder='红人Id' clearable></el-input>
            </el-form-item>
            <el-form-item label='红人昵称(星广汇)'>
              <el-input v-model='searchCondition.ad_nickname' class='artist-compare-name-input'
                        placeholder='红人昵称' clearable></el-input>
            </el-form-item>

            <el-form-item label='创建时间'>
              <el-date-picker
                v-model='searchCondition.date_range'
                class='artist-compare-date-range'
                type='daterange'
                align='right'
                unlink-panels
                range-separator='至'
                start-placeholder='开始日期'
                end-placeholder='结束日期'
                value-format='yyyy-MM-dd'
                :picker-options='pickerOptions'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading' @click='handleQuery'>搜索</el-button>
            </el-form-item>
          </el-form>
          <div class='artist-compare-actions'>
            <el-button plain size='medium' icon='el-icon-plus' v-if='hasAuthority("artist_compare__add")' @click='handleAdd'>新增</el-button>
            <el-button plain size='medium' icon='el-icon-refresh' @click='handleSync' :disabled='loadingCommit' :loading='loadingCommit'>同步昵称</el-button>
          </div>
        </div>
        <!--    渲染表格-->
        <div ref='compareTableSection' class='default-table artist-compare-table-section'>
          <MlPageTable class='artist-compare-table'
                       :all-columns='defaultColumns'
                       :table-name='tableName'
                       :data-list='dataList'
                       :limit.sync='pageData.page_size'
                       :page.sync='pageData.current_page'
                       :total.sync='total'
                       :height='height'
                       highlight-current-row
                       :row-class-name='tableRowClassName'
                       @row-click='rowClickEvent'
                       @getList='getList'>
            <el-table-column align='center' width='160' label='操作'>
              <template slot-scope='{row,$index}'>
                <div class='artist-compare-row-actions'>
                  <el-button class='artist-compare-edit-btn' plain size='mini' icon='el-icon-edit'
                             v-if='hasAuthority("artist_compare__edit")'
                             @click='handleEdit(row)'>修改</el-button>
                  <el-button class='artist-compare-delete-btn' plain size='mini' icon='el-icon-delete'
                             v-if='hasAuthority("artist_compare__delete")'
                             @click='handleDelete(row,$index)'>删除</el-button>
                </div>
              </template>
            </el-table-column>
          </MlPageTable>
        </div>
      </div>

      <!-- 添加或修改对话框 -->
      <el-dialog :title='title + "红人对照"' :visible.sync='open' width='800px' append-to-body
                 :close-on-click-modal='false'>
        <el-form v-loading="DialogLoading" ref='form' :model='form' :rules='rules' label-width='120px'>
          <el-form-item label='红人(星象仪)' prop='artist_id'>
            <select-artist :placeholder="'红人(星象仪)'" :value.sync="form.artist_id"
                           :label.sync="form.nickname"/>
          </el-form-item>
          <el-form-item label='红人(星广汇)' prop='ad_artist_id'>
            <select-ad-artist :placeholder="'红人(星广汇)'" :value.sync="form.ad_artist_id"
                              :label.sync="form.ad_nickname"/>
          </el-form-item>
        </el-form>
        <div slot='footer' class='dialog-footer'>
          <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
          </el-button>
          <el-button @click='cancel'>取 消</el-button>
        </div>
      </el-dialog>
    </PageHeaderLayout>
  </div>
</template>

<script>
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import {
  addArtistCompare,
  deleteArtistCompare,
  editArtistCompare,
  getArtistCompareInfo,
  getArtistCompareList, syncAdArtistNickname
} from '@/api/artist_compare'
import SelectArtist from '@/components/select/artist.vue'
import SelectAdArtist from '@/components/select/ad-artist.vue'
import {hasAuthority} from "@/utils/hasAuthority";

export default {
  name: 'ArtistCompareList',
  components: { SelectAdArtist, SelectArtist, ExportBtn, PageHeaderLayout, MlPageTable },
  data() {
    return {
      tableName: 'artist_compare',
      loading: false,
      loadingCommit: false,
      dataList: [],
      total: 0,
      height: 420,
      searchCondition: { date_range: [],artist_id: null, nickname: null, ad_artist_id: null, ad_nickname: null},
      pageData: { current_page: 1, page_size: 20 },
      orderBy: { id: 'desc' },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns:  [{ hide: false, prop: 'id', label: '序号', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'artist_id', label: '红人ID(星象仪)', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'nickname', label: '红人昵称(星象仪)', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'ad_artist_id', label: '红人ID(星广汇)', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'ad_nickname', label: '红人昵称(星广汇)', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: true, fixed: false }],
      // 弹出层标题
      title: '添加/修改-',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules:{artist_id: [{ required: true, message: '(星象仪)红人Id不能为空', trigger: 'blur' }],
        nickname: [{ required: true, message: '红人昵称不能为空', trigger: 'blur' }],
        ad_artist_id: [{ required: true, message: '(星广汇)红人Id不能为空', trigger: 'blur' }],
        ad_nickname: [{ required: true, message: '红人昵称不能为空', trigger: 'blur' }]},
      // 表单参数
      form: {},
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey: 'page_search_key:artist_compare',
      DialogLoading: true
    }
  },
  mounted() {
    this.$nextTick(this.setTableHeight)
    window.addEventListener('resize', this.setTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  },
  methods: {
    hasAuthority,
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    },
    setTableHeight() {
      const section = this.$refs['compareTableSection']
      if (!section) {
        return
      }
      const tableWrap = section.querySelector('.ml-page-table')
      const footer = section.querySelector('.ml-page-table__footer')
      const availableHeight = tableWrap ? tableWrap.clientHeight : section.clientHeight
      const footerHeight = footer ? footer.offsetHeight + 10 : 58
      this.height = Math.max(availableHeight - footerHeight, 260)
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field]) {
          condition[field] = this.searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      const params = this.handleSearchCondition()
      const { list, pages } = await getArtistCompareList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
      this.$nextTick(this.setTableHeight)
    },
    /** 删除按钮 */
    handleDelete(row, index) {
      if (row.id) {
        //真实删除
        this.$confirm('此操作将删除（序号[' + row.id + ']）该行数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const id = this.delRow(row.id)
          if (id) {
            this.$message({type: 'success', message: '删除成功'})
          } else {
            this.$message({type: 'error', message: '删除失败'})
          }
          this.dataList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    async delRow(id) {
      return await deleteArtistCompare(id)
    },
    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.DialogLoading = true
      this.title = '添加-'
      this.form = {}
      this.DialogLoading = false
    },
    /** 修改按钮 */
    async handleEdit(row) {
      this.open = true
      this.DialogLoading = true
      this.title = '修改-'
      const { info } = await getArtistCompareInfo(row.id)
      this.form = { ...info }
      delete this.form.created_at
      delete this.form.updated_at
      this.DialogLoading = false
    },

    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          if (this.form.id) {
            editArtistCompare(this.form).then(id => {
              if (id) {
                if (!this.form.id)
                  this.msgSuccess('新增成功')
                else
                  this.msgSuccess('修改成功')

                this.form.id = id
                this.open = false
                this.getList()
              } else {
                this.msgError('操作失败')
              }
              setTimeout(() => {
                this.loadingCommit = false
              }, 500)
            })
          } else {
            addArtistCompare(this.form).then(id => {
              if (id) {
                if (!this.form.id)
                  this.msgSuccess('新增成功')
                else
                  this.msgSuccess('修改成功')

                this.form.id = id
                this.open = false
                this.getList()
              } else {
                this.msgError('操作失败')
              }
              setTimeout(() => {
                this.loadingCommit = false
              }, 500)
            })
          }
        }
      })
    },
    /** 同步 */
    async handleSync() {
      this.loadingCommit = true
      syncAdArtistNickname().then( data => {
        setTimeout(() => {
          this.loadingCommit = false
          this.msgSuccess(data)
        }, 500)
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  }
}
</script>

<style lang='scss' scoped>
.artist-compare-page {
  height: calc(100vh - 106px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 12px 16px 12px;
  background: #f5f6f8;
}

.artist-compare-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(30, 41, 59, .04);
}

.artist-compare-search-form {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.artist-compare-actions {
  display: flex;
  flex: 0 0 auto;
  min-width: max-content;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.artist-compare-table-section {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 8px 10px 10px 10px;
  background: #fff;
}

.artist-compare-table {
  height: 100%;
}

.artist-compare-id-input {
  width: 148px;
}

.artist-compare-name-input {
  width: 176px;
}

.artist-compare-date-range {
  width: 270px;
}

.artist-compare-toolbar ::v-deep .el-form-item {
  margin: 0;
}

.artist-compare-toolbar ::v-deep .el-form-item__label,
.artist-compare-toolbar ::v-deep .el-form-item__content {
  line-height: 32px;
}

.artist-compare-toolbar ::v-deep .el-form-item__label {
  padding-right: 6px;
  color: #606266;
  font-weight: 500;
}

.artist-compare-toolbar ::v-deep .el-input__inner,
.artist-compare-toolbar ::v-deep .el-range-editor.el-input__inner,
.artist-compare-toolbar ::v-deep .el-button {
  height: 32px;
  line-height: 30px;
}

.artist-compare-toolbar ::v-deep .el-button {
  padding: 0 14px;
}

.artist-compare-toolbar ::v-deep .el-range-editor.el-input__inner {
  padding: 3px 10px;
}

.artist-compare-toolbar ::v-deep .el-date-editor .el-range__icon,
.artist-compare-toolbar ::v-deep .el-date-editor .el-range__close-icon,
.artist-compare-toolbar ::v-deep .el-date-editor .el-range-separator {
  line-height: 24px;
}

.artist-compare-toolbar ::v-deep .el-button--primary {
  background-color: #ff3176;
  border-color: #ff3176;
}

.artist-compare-toolbar ::v-deep .el-button--primary:hover,
.artist-compare-toolbar ::v-deep .el-button--primary:focus {
  background-color: #ff5c92;
  border-color: #ff5c92;
}

.artist-compare-actions ::v-deep .el-button {
  margin: 0;
  color: #ff3176;
  background: #fff;
  border-color: #ff9cbd;
}

.artist-compare-actions ::v-deep .el-button:hover,
.artist-compare-actions ::v-deep .el-button:focus {
  color: #ff3176;
  background: #fff4f8;
  border-color: #ff3176;
}

.artist-compare-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}

.artist-compare-row-actions ::v-deep .el-button {
  margin: 0;
  padding: 5px 9px;
  color: #ff3176;
  background: #fff;
  border-color: #ff9cbd;
}

.artist-compare-row-actions ::v-deep .el-button:hover,
.artist-compare-row-actions ::v-deep .el-button:focus {
  color: #ff3176;
  background: #fff4f8;
  border-color: #ff3176;
}

.artist-compare-row-actions ::v-deep .el-button + .el-button {
  margin-left: 0;
}

.artist-compare-row-actions ::v-deep .artist-compare-delete-btn {
  color: #f56c6c;
  border-color: #f8b4b4;
}

.artist-compare-row-actions ::v-deep .artist-compare-delete-btn:hover,
.artist-compare-row-actions ::v-deep .artist-compare-delete-btn:focus {
  color: #f56c6c;
  background: #fff5f5;
  border-color: #f56c6c;
}

.artist-compare-table-section ::v-deep .ml-page-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.artist-compare-table-section ::v-deep .el-table {
  flex: 1 1 auto;
}

.artist-compare-table-section ::v-deep .ml-page-table__footer {
  flex: 0 0 auto;
  gap: 12px;
  margin-top: 10px !important;
}

.artist-compare-table-section ::v-deep .ml-page-table__footer > .el-col:first-child {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.artist-compare-table-section ::v-deep .ml-page-table__footer > .el-col:last-child {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
}

.artist-compare-table-section ::v-deep .pagination-container {
  padding: 0;
  text-align: right;
}

.artist-compare-table-section ::v-deep .el-pagination {
  padding: 0;
  line-height: 28px;
}

.artist-compare-table-section ::v-deep .el-pagination__total,
.artist-compare-table-section ::v-deep .el-pagination__sizes,
.artist-compare-table-section ::v-deep .el-pagination__jump {
  height: 28px;
  line-height: 28px;
}

.artist-compare-table-section ::v-deep .el-pagination.is-background .btn-prev,
.artist-compare-table-section ::v-deep .el-pagination.is-background .btn-next,
.artist-compare-table-section ::v-deep .el-pagination.is-background .el-pager li {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  margin: 0 3px;
}

.artist-compare-table-section ::v-deep .el-pagination .el-input__inner {
  height: 28px;
  line-height: 28px;
}

@media (max-width: 1280px) {
  .artist-compare-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .artist-compare-actions {
    justify-content: flex-start;
  }
}
</style>
